export default __webpack_public_path__ + "2db53a3f71801e04d2c72672b059cf87.svg";